import PropTypes from "prop-types";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DescriptionIcon from "@mui/icons-material/Description";
import CreateIcon from "@mui/icons-material/Create";
import GridOnIcon from "@mui/icons-material/GridOn";
import { ORDER } from "constants/routes";

const CreateOrderModal = ({ open, onClose, onCreate }) => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleConfirm = () => {
    if (selectedOption === "pdf") {
      // Navigate to order screen for PDF import
      navigate(ORDER);
      onClose();
    } else if (selectedOption === "manual") {
      // Call the onCreate function for manual order creation
      onCreate();
      onClose();
    }
  };

  const handleClose = () => {
    setSelectedOption(null);
    onClose();
  };

  const options = [
    {
      id: "pdf",
      title: "Import order via PDF",

      icon: <DescriptionIcon />,
    },
    {
      id: "manual",
      title: "Create manual orders",

      icon: <CreateIcon />,
    },
    {
      id: "bulk",
      title: "Upload bulk order sheet (CSV)",

      icon: <GridOnIcon />,
    },
  ];

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create New Order</DialogTitle>
      <DialogContent>
        <List>
          {options.map((option) => (
            <ListItem key={option.id} disablePadding>
              <ListItemButton
                selected={selectedOption === option.id}
                onClick={() => handleOptionSelect(option.id)}
                sx={{
                  borderRadius: 1,
                  mb: 1,
                  "&.Mui-selected": {
                    backgroundColor: "primary.main",
                    color: "primary.contrastText",
                    "&:hover": {
                      backgroundColor: "primary.dark",
                    },
                    "& .MuiListItemIcon-root": {
                      color: "primary.contrastText",
                    },
                  },
                }}
              >
                <ListItemIcon>{option.icon}</ListItemIcon>
                <ListItemText primary={option.title} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={!selectedOption}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CreateOrderModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
};

export default CreateOrderModal;
